import React from "react";
import "./notickets.css";

function NoTickets() {
  return (
    <div className="no-tickets-container">
      <div className="empty-state-card">
        <div className="illustration"></div>
        <h1 className="title">No Tickets Yet</h1>
        <p className="subtitle">
          "No support tickets available right now. You'll be notified when new
          ones are assigned."
        </p>
        <div className="features-hint">
          <p>
            Once tickets are created, you can assign them, track progress, and
            collaborate in real-time.
          </p>
        </div>
      </div>
    </div>
  );
}

export default NoTickets;
